<template>
  <section class="qs-section">
    <header class="qs-section__header">
      <div class="qs-section__heading">
        <img
          :src="iconUrl || section.iconUrl"
          alt=""
          class="qs-section__icon-image"
        />
        <h2 class="qs-section__title">{{ section.title }}</h2>
      </div>
      <p class="qs-section__description">{{ section.description }}</p>
    </header>

    <div class="qs-section__steps">
      <StepRow
        v-for="(step, index) in section.steps"
        :key="step.key"
        :step="step"
        :index="index + 1"
        :section-name="sectionName"
        :organization-id="organizationId"
      />
    </div>
  </section>
</template>

<script>
import StepRow from './StepRow.vue';

export default {
  name: 'QuickStartSection',
  components: { StepRow },
  props: {
    section: {
      type: Object,
      required: true,
    },
    sectionName: {
      type: String,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    // Overrides section.iconUrl for sections whose icon is a static client asset (e.g. Basics)
    // rather than a value that varies per organization (e.g. the secondary-path icon).
    iconUrl: {
      type: String,
      default: null,
    },
  },
};
</script>
